import { FormEndAdornmentTypes } from '../../../constants/form/form';
import ClearEndAdornment from './ClearEndAdornment/ClearEndAdornment';

const endAdornmentMap = {
  [FormEndAdornmentTypes.Clear]: ClearEndAdornment,
};

export const getEndAdornment = (endAdornmentType: FormEndAdornmentTypes) =>
  endAdornmentMap[endAdornmentType];
